import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addStockReconcillation = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Stock Reconciliation',
    body
  );
  return data;
});
export const updateStockReconcillation = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Stock Reconciliation/${id}`,
    body
  );
  return data;
});

export const getStockReconcillation = catchAsync(async ({key="",value=""}) => {
  let baseUrl =  '/api/resource/Stock Reconciliation?fields=["purpose","posting_date","difference_amount","name","docstatus"]&limit_page_length=0'
  if(value){
    baseUrl += `&filters=[["${key}","like","%${value}%"]]`;
}
  const { data } = await axiosInstance.get(
    baseUrl
  );
  return data;
});
export const deleteStockReconcillation = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Stock Reconciliation/${record}`
  );
  return data;
});
export const getStockReconcillationDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Stock Reconciliation/${id}`
  );
  return data;
});
